import { IXElementContentsObjectBean, IXElementContentsObjectRelationalBean } from "../../../beans";
import { RelationTranslator } from "./RelationTranslator";

export class DesignatedDoctorTypeTranslator {
  from(bean: IXElementContentsObjectBean): string {
    return this.relationalItems.from(
      bean,
      is => is[0]["@value"] as string,
      null);
  }

  to(object: string): IXElementContentsObjectRelationalBean {
    return object
      ? this.relationalItems.to([{
        "@value-type": "1",
        "@value": object,
      }])
      : undefined;
  }
  private readonly relationalItems = new RelationTranslator("designate-doctor");
}
